module.exports = __webpack_public_path__ + "img/a.f102fc68.jpg";